var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-hero"},[_c('div',{staticClass:"hero-text-box"},[_c('h2',[_vm._v(_vm._s(_vm.headerTop))]),_c('h2',[_vm._v(_vm._s(_vm.headerBottom))])]),_c('div',{staticClass:"home-hero-changer"},[_c('div',{staticClass:"hero-filter"}),_c('div',{staticClass:"main-hero",style:({ backgroundImage: `url('${_vm.imageSrc}')` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }